import { render, staticRenderFns } from "./LpuShareBtn.vue?vue&type=template&id=53e7d73e&"
import script from "./LpuShareBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuShareBtn.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e7d73e')) {
      api.createRecord('53e7d73e', component.options)
    } else {
      api.reload('53e7d73e', component.options)
    }
    module.hot.accept("./LpuShareBtn.vue?vue&type=template&id=53e7d73e&", function () {
      api.rerender('53e7d73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuShareBtn.vue"
export default component.exports